import React from 'react';
import { QueryProvider } from './providers/QueryProvider';
import { AppRouter } from './routes';
import ErrorBoundary from './components/ErrorBoundary';
import { SessionManager } from './components/SessionManager';
import { WorkspaceInitializer } from './components/WorkspaceInitializer';
import { NotificationStreamProvider } from './components/NotificationStreamProvider';
import { NotificationToast } from './components/NotificationToast';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <QueryProvider>
        <SessionManager />
        <WorkspaceInitializer />
        <AppRouter />
        <NotificationStreamProvider />
        <NotificationToast />
      </QueryProvider>
    </ErrorBoundary>
  );
};

export default App;